export enum JobCodes {
  HOME = "UK-MULT-88 | January 2024",
  ALGORITHM = "UK-MULT-89 | January 2024",
  PRODUCTS = "UK-MULT-90 | January 2024",
  CONTRIBUTORS = "UK-MULT-91 | January 2024",
  PRESCRIBING_INFORMATION = "UK-MULT-103 | January 2024",
}
